// ENABLE APP
window.shipping_protection_enabled = true;
window.protectionFixed = true;
//console.log(window.shipping_protection_enabled);


if(document.getElementById('protection-block')){
  document.getElementById("protection-status").checked = true;
}

//WRAP ARROUND GEO
$.getJSON( "/browsing_context_suggestions.json", function(json) {
   if (json.detected_values.country_name == 'Bangladesh' || json.detected_values.country_name == 'Australia' ){

    function updateShippingInfo() {
        let pricingData = document.querySelector("#pricing-data");

        if (pricingData) {
            let cartTotal = parseInt(pricingData.getAttribute("data-current-total"), 10) / 100; // Convert cents to dollars
            
            if(document.getElementById('protection-block')){
                let variantId = document.querySelector("#protection-block")?.getAttribute("data-sp-key")?.split(":")[0] || null;
                const discountMap = {
                    40778104569914: 3,
                    40778104602682: 5,
                    40778104635450: 8,
                    40778104668218: 11,
                    40778104700986: 14,
                    40778104733754: 17,
                    40778104766522: 22
                };
                
                // Deduct value if variantId exists in the map
                if (discountMap[variantId]) {
                    cartTotal -= discountMap[variantId];
                }
              }
            
            let shippingData = [
                { max: 100, cost: 3, id: 40778104569914 },
                { max: 200, cost: 5, id: 40778104602682 },
                { max: 300, cost: 8, id: 40778104635450 },
                { max: 400, cost: 11, id: 40778104668218 },
                { max: 500, cost: 14, id: 40778104700986 },
                { max: 600, cost: 17, id: 40778104733754 },
                { max: Infinity, cost: 22, id: 40778104766522 }
            ];

            let shipping;
            if (window.protectionFixed === true) {
                shipping = { cost: 3.49, id: 40778511188026 };
                window.shippingCost = 3.49;  // Override shipping cost
                window.shippingId = 40778511188026;  // Override shipping ID
            } else {
                shipping = shippingData.find(item => cartTotal < item.max);
                window.shippingCost = shipping.cost;
                window.shippingId = shipping.id;
            }

            // Update shipping cost
            let shippingCostElement = document.querySelector(".price-block-dymanic");
            if (shippingCostElement) {
                shippingCostElement.textContent = `${shipping.cost}`;
            }

            // Update shipping ID
            let shippingIdElement = document.querySelector("#v-id");
            if (shippingIdElement) {
                shippingIdElement.textContent = shipping.id;
            }

            //console.log("Updated Shipping Cost:", shipping.cost);
            //console.log("Updated Shipping ID:", shipping.id);
        }
    }

    // Run the function initially
    updateShippingInfo();

     //NEW
    if (document.getElementById('protection-block')!= null){
      window.hasProtection_shipping = true;
      document.getElementById("protection-status").checked = true;
    } 
    else {
      window.hasProtection_shipping = false;
      if (document.getElementById("protection-status")!= null){document.getElementById("protection-status").checked = false;}
    }
    
    //CHANGE QUANTITY
    async function lineItemQuantityChange_(lineKey, targetQuantity) {
      const lineItem = document.getElementById('protection-block');
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: lineKey,
          quantity: targetQuantity,
          sections: sectionsToBundle
        }
      }).then((data) => {
        const lineItemAfterChange = data["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
        lineItem?.dispatchEvent(new CustomEvent("line-item:change", { 
          bubbles: true, 
          detail: { 
            quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"], 
            cart: data 
          } 
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true, 
          detail: { 
            //baseEvent: "line-item:change",
            cart: data 
          } 
        }));
        document.querySelector('free-shipping-bar')?.setAttribute('total-price', data.total_price);
      });
    }
    
    //ADD ITEM
    async function addItem_(variant, form) {
      const formElement = document.getElementById(form);
      //console.log(formElement);
      let sectionsToBundle = ["variant-added"];

      // [Added] Get current cart contents
      const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
      const cartContent = await cartResponse.json();
      
      // [Added] Check if the variant is already in the cart
      const existingItem = cartContent.items.find(item => item.variant_id === window.shippingId);
      if (existingItem) {
          //console.log("Item with variant ID -- is already in the cart.");
          return; // [Added] Stop execution if the item is already in the cart
      }
      
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const formData = new FormData(formElement);
      formData.append("id", variant);
      formData.set("sections", sectionsToBundle.join(","));
      formData.set("sections_url", `${Shopify.routes.root}variants/${variant}`);
      formData.set("quantity", 1);
    
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }); 
      
      const responseJson = await response.json();
      if (response.ok) { 
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();   
        cartContent["sections"] = responseJson["sections"];
        formElement.dispatchEvent(new CustomEvent("variant:add", { 
          bubbles: true, 
          detail: { 
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson], 
            cart: cartContent 
          } 
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", { 
          bubbles: true, 
          detail: { 
            //baseEvent: "variant:add",
            cart: cartContent 
          } 
        }));  
        document.querySelector('free-shipping-bar')?.setAttribute('total-price', cartContent.total_price);
      } else {   
        this.dispatchEvent(new CustomEvent("cart:error", { 
          bubbles: true, 
          detail: { 
            error: responseJson["description"] 
          } 
        }));   
      }
    }
    
    // Add a click event listener to the input element inside 'line-item-quantity'
    var inputElement = document.getElementById('protection-status');

    //console.log(inputElement);
    if (inputElement) {
      inputElement.addEventListener('click', function () {

        if (window.shipping_protection_enabled) {
        
          //console.log("Checkbox: Clicked");
          document.cookie = "shipping_protection=has_shipping_protection_preference";
      
          if (document.getElementById("protection-status") != null) {
            document.getElementById("protection-status").disabled = true;
            setTimeout(function(){document.getElementById("protection-status").disabled = false;},2000);
          }
          
          if (document.getElementById("protection-status").checked) {
            //console.log("Checked: Start Adding");
            addItem_(shippingId, "protection");
          }
          if (!document.getElementById("protection-status").checked) {
            //console.log("Unchecked: Start Removing");
            if (document.getElementById('protection-block') != null) {
              lineItemQuantityChange_(parseInt(document.getElementById('protection-block').getAttribute('data-sp-key')), 0);
            }
          }
          
        }
      });
    }
    
    async function checkElementExists(element, timeout = Infinity) {
      let startTime = Date.now();
      return new Promise((resolve) => {
        const intervalId = setInterval(() => {
          if (document.querySelector(element)) {
            clearInterval(intervalId);
            resolve(true);
          } else if (Date.now() - startTime >= timeout * 1000) {
            clearInterval(intervalId);
            resolve(false);
          }
        }, 100);
      });
    }	  
        
    
    document.addEventListener('cart:change', function(event) {

      //console.clear();

      if (window.shipping_protection_enabled) {
      // auto add once
      let cart_total_pro = event.detail.cart.total_price;

      // dymanic
      function updateShippingInfo() {
        
        let pricingData = event.detail.cart.total_price;

        if (pricingData) {
            let cartTotal = pricingData / 100; // Convert cents to dollars          

            const product_check_pro = event.detail.cart.items;
            const variant_check_pro = 7379348586554;

            const discountMap = {
                        40778104569914: 3,
                        40778104602682: 5,
                        40778104635450: 8,
                        40778104668218: 11,
                        40778104700986: 14,
                        40778104733754: 17,
                        40778104766522: 22
            };

            let shippingData = [
                { max: 100, cost: 3, id: 40778104569914 },
                { max: 200, cost: 5, id: 40778104602682 },
                { max: 300, cost: 8, id: 40778104635450 },
                { max: 400, cost: 11, id: 40778104668218 },
                { max: 500, cost: 14, id: 40778104700986 },
                { max: 600, cost: 17, id: 40778104733754 },
                { max: Infinity, cost: 22, id: 40778104766522 }
            ];
                          

            if (window.protectionFixed === true) {
                shipping = { cost: 3.49, id: 40778511188026 };
                window.shippingCost = 3.49;  // Override shipping cost
                window.shippingId = 40778511188026;  // Override shipping ID
            } else {
                shipping = shippingData.find(item => cartTotal < item.max);
                window.shippingCost = shipping.cost;
                window.shippingId = shipping.id;

              for (let i = 0; i < product_check_pro.length; i++) {
                  if (product_check_pro[i].product_id == variant_check_pro) {
                      // Perform actions when the product is found
                      console.log("Product found:", product_check_pro[i].variant_id);
                      let variantId = product_check_pro[i].variant_id; 
                      let variantKey = product_check_pro[i].key;
                      let variantQuantity = product_check_pro[i].quantity;
                      //console.log(product_check_pro[i]);
                    
                      // Deduct value if variantId exists in the map
                      if (discountMap[variantId]) {
                          cartTotal -= discountMap[variantId];
                      }
  
                      // Determine correct shipping based on cart total
                      let correctShipping = shippingData.find(item => cartTotal < item.max);
                      let correctVariantId = correctShipping.id;
          
                      //console.log("Correct Shipping Cost:", correctShipping.cost);
                      //console.log("Correct Shipping ID:", correctVariantId);
  
                      // Check if the variant in the cart is incorrect
                      if (variantId !== correctVariantId) {
                          //console.log(variantKey);
                          lineItemQuantityChange_(variantKey, 0);
                          console.log("Removed Shipping ID:", variantId);
                          console.log("Correct Shipping ID:", correctVariantId);
                          //addItem_(correctVariantId, "protection");
                      }
  
                      // Check if the variant in the cart is incorrect
                      if (variantQuantity > 1) {
                          lineItemQuantityChange_(variantKey, 1);
                          console.log("Correct Quantity Fix:", variantId);
                      }
                    
                      break; // Exit the loop only when the condition is met
                  }
              }
               
            }

            // Update shipping cost
            let shippingCostElement = document.querySelector(".price-block-dymanic");
            if (shippingCostElement) {
                shippingCostElement.textContent = `${shipping.cost}`;
            }

            // Update shipping ID
            let shippingIdElement = document.querySelector("#v-id");
            if (shippingIdElement) {
                shippingIdElement.textContent = shipping.id;
            }

            //console.log("Updated Shipping Cost:", shipping.cost);
            //console.log("Updated Shipping ID:", shipping.id);
        }
    }

    // Run the function initially
    updateShippingInfo();

        
      if (cart_total_pro > 0) {
        //console.log("Searching");
        const product_check_pro = event.detail.cart.items; 
        const variant_check_pro = 7379348586554;
        for (var i = 0; i < product_check_pro.length; i++) {
          if (product_check_pro[i].product_id == variant_check_pro) {
             window.hasProtection_shipping = true;
             if (!document.getElementById("protection-status").checked){document.getElementById("protection-status").checked = true;}
             // fix quantity
             if(product_check_pro[i].quantity>1) { 
               lineItemQuantityChange_(product_check_pro[i].key, 1); 
               //console.log("_____________quantity__________________");
               break;
             }
             //remove if everything removed from cart
             if(event.detail.cart.item_count == 1) { 
               document.getElementById("protection-status").checked = false; 
               lineItemQuantityChange_(product_check_pro[i].key, 0);
               //console.log("______________remove_________________");
               break;
             }
             //console.log("Has Item");
             break;
          } else {
            window.hasProtection_shipping = false;
            if (document.getElementById("protection-status")!= null){document.getElementById("protection-status").checked = false;}
            //console.log("No Item");
          }
        } 
      }
    
      const shipping_protection = document.cookie.split('; ').find(row => row.startsWith('shipping_protection='))?.split('=')[1] || null;
      //console.log("Shipping Preference: "+shipping_protection+"");
      //console.log("Protection Added: "+window.hasProtection_shipping+"");
      //console.log("Boxed Checked: "+document.getElementById("protection-status").checked+"");
    
      checkElementExists("#protection", 5)
      .then((result) => {
        if (result) {
            //console.log("The element exists!");
          if (!window.hasProtection_shipping && shipping_protection == null) { 
            //addItem_(window.shippingId, "protection"); 
            document.cookie = "shipping_protection=has_shipping_protection_preference";
          }
        } else {
          //console.log("The element does not exist after 5 seconds");
        }
      });
      }
    });
     ///
   } else { 
     $(".shipping-protection").hide(); 
     $('head').append('<style type="text/css">#cart-drawer .shipping-protection { display: none !important; }</style>');
     async function lineItemQuantityChange__(e,t){let n=document.getElementById("protection-block");n?.dispatchEvent(new CustomEvent("line-item:will-change",{bubbles:!0,detail:{targetQuantity:t}}));let a=[];document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections",{bubbles:!0,detail:{sections:a}})),$.ajax({type:"POST",url:"/cart/change.js",dataType:"json",data:{id:e,quantity:t,sections:a}}).then(t=>{let a=t.items.filter(t=>t.key===e);n?.dispatchEvent(new CustomEvent("line-item:change",{bubbles:!0,detail:{quantity:0===a.length?0:a[0].quantity,cart:t}})),document.documentElement.dispatchEvent(new CustomEvent("cart:change",{bubbles:!0,detail:{cart:t}}))})}document.getElementById("protection-block")&&(console.log("Remove"),lineItemQuantityChange__(parseInt(document.getElementById("protection-block").getAttribute("data-sp-key")),0));
   }
});
